import { render, staticRenderFns } from "./ScanForFour.vue?vue&type=template&id=c05c440a&scoped=true"
import script from "./ScanForFour.vue?vue&type=script&lang=js"
export * from "./ScanForFour.vue?vue&type=script&lang=js"
import style0 from "./ScanForFour.vue?vue&type=style&index=0&id=c05c440a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05c440a",
  null
  
)

export default component.exports